// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__diw4R","selects":"Documents_selects__1QWsl"};